function CommonLoader() {
  return <div style={{ textAlign: "center" }}>Loading...</div>;
}

export default CommonLoader;
